export class Asset {
  constructor(public assetId: string, public name: string, public mimeType: string) {}
}
